import { render, staticRenderFns } from "./FmlTags.vue?vue&type=template&id=b5813c74&"
import script from "./FmlTags.vue?vue&type=script&lang=js&"
export * from "./FmlTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports